import SyconfirmPopup from "./sy-confirmpopup";



export default SyconfirmPopup